import React, { useEffect, useState } from "react";
import BiljeskeDataTable from "../components/BiljeskeDataTable";
import BiljeskeGroupedDataTable from "../components/BiljeskeGroupedDataTable";
import UnauthorizedAccess from "../components/UnauthorizedAccess";
import InternalServerError from "../components/InternalServerError";

export const Biljeske = ( props ) => {
  const [biljeskaGodine, setBiljeskaGodine] = useState(null);
  const [biljeskaPolaznika, setBiljeskaPolaznika] = useState(null);
  const [restData, setRestData] = useState(null);
  const [fetchState, setFetchState] = useState(null);

  useEffect( () => {
    if ( sessionStorage.getItem("razredPregleda") !== null && sessionStorage.getItem("razredPregleda") === '1') setBiljeskaGodine(sessionStorage.getItem("biljeskePrveGodine"));
    else if ( sessionStorage.getItem("razredPregleda") !== null && sessionStorage.getItem("razredPregleda") === '2') setBiljeskaGodine(sessionStorage.getItem("biljeskeDrugeGodine"));
    else if ( sessionStorage.getItem("razredPregleda") !== null && sessionStorage.getItem("razredPregleda") === '3') setBiljeskaGodine(sessionStorage.getItem("biljeskeTreceGodine"));
    else setBiljeskaGodine(sessionStorage.getItem("biljeskeCetvrteGodine"));
    
    setBiljeskaPolaznika(sessionStorage.getItem("biljeskaPolaznika"));
    
    fetch(
      props.rest +
        sessionStorage.getItem("ustanova") +
        "&prema_obliku=" +
        sessionStorage.getItem("premaObliku") +
        "&godina_upisa=" +
        sessionStorage.getItem("godinaUpisa") +
        "&redni_broj=" +
        sessionStorage.getItem("redniBroj") +
        "&razred=" +
        sessionStorage.getItem("razredPregleda"),
      {
        method: "GET",
        mode: "cors",
        credentials: "include",
        headers: {
          Authorization: sessionStorage.getItem("token"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    )
    .then((response) => {
      //console.log("Response ocjene: " + response);
      if (response.status === 200) {
        setFetchState(200);
        return response.json();
      } else if (response.status === 204) {
        setFetchState(204);
        return null;
      } else if (response.status === 401) {
        setFetchState(401);
        return null;
      } else if (response.status === 500) {
        setFetchState(500);
        return null;
      } else {
        return null;
      }
    })
    .then((data) => {
      //console.log("Data stringify test:" + JSON.stringify(data));
      setRestData(data);
    })
    .catch((err) => {
      //console.log("Error ocjene:" + err);
    });
  }, [props.rest]);

  return (
    <div>
      {biljeskaGodine === null || biljeskaGodine === "null" ? <></> : 
          <>
            <p className="biljeska-title">Bilješka {sessionStorage.getItem("razredPregleda")}. razreda:</p>
            <br></br>
            <p className="biljeska-title">{biljeskaGodine}</p>
            <br></br>
          </>
      }
      {biljeskaPolaznika === null || biljeskaPolaznika === "null" ? <></> : 
          <>
            <p className="biljeska-title">Bilješka polaznika::</p>
            <br></br>
            <p className="biljeska-title">{biljeskaPolaznika}</p>
            <br></br>
          </>
      }
      {fetchState === 200 ? (
          <><p className="page-title">Pregled svih bilješki za {sessionStorage.getItem("razredPregleda")}. razred</p>
            <BiljeskeDataTable data={restData} />{" "}
            <p className="page-title">Pregled bilješki po predmetu za {sessionStorage.getItem("razredPregleda")}. razred</p>
            <BiljeskeGroupedDataTable data={restData} />
          </>
      ) : (
        ""
      )}
      {fetchState === 401 ? <UnauthorizedAccess /> : ""}
      {fetchState === 500 ? <InternalServerError /> : ""}
    </div>
  );
};

export default Biljeske;